import { Col, Modal, Row, Space } from 'antd';
import styles from './index.module.sass';
import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { ButtonPrimary } from '@/shared/ui/button';
import classNames from 'classnames';
import { useAddBuyerFormState } from '../../hooks/use-add-buyer.hook';
import { BuyerInstance, SuccessResponse } from '../../ts';
import { useEffect, useState } from 'react';
import {
  $addressOptions,
  $requisiteOptions,
  clearAddressOptions,
  clearRequisiteOptions,
  searchBuyersAddressFx,
  searchBuyersRequisitesFx,
  setAddressOptions,
  setRequisiteOptions,
} from '../../store/buyers.store';
import { useStore } from 'effector-react';

export const AddBuyerModal = ({ visible, closeFn, handleSubmit }: IAddBuyerModal) => {
  const { formState, handleChange, resetForm, setFormState } = useAddBuyerFormState();

  useEffect(() => {
    return () => {
      resetForm();
      clearAddressOptions();
      clearRequisiteOptions();
    };
  }, []);

  useEffect(() => {
    resetForm();
    clearAddressOptions();
    clearRequisiteOptions();
  }, [closeFn]);

  const addressOptions: any = useStore($addressOptions);
  const requisiteOptions: {
    name: string;
    inn: string;
    ogrn: string;
    address: { city: string; country: string; house: string; street: string };
  }[] = useStore($requisiteOptions);
  const [selectedAddressOption, setSelectedAddressOption] = useState({
    value: null,
    region: null,
    city: null,
    street: null,
    house: null,
  });
  return (
    <Modal
      width={920}
      title={'добавление покупателя'}
      open={visible}
      onCancel={() => {
        closeFn();
        resetForm();
      }}
      footer={[]}
    >
      <InputWithSign
        className={classNames(styles.input)}
        label="название компании*"
        placeholder=""
        value={formState.companyName}
        postfix=""
        autoComplete="off"
        onChange={(e) => {
          handleChange('companyName', e.target.value);
          searchBuyersRequisitesFx(formState.companyName);
        }}
        options={
          Array.isArray(requisiteOptions)
            ? requisiteOptions
                ?.map((item: any) => ({ label: item.name, inn: item.inn }))
                .filter(
                  (value: { label: string; inn: string }, index: number, self: any) =>
                    index ===
                    self.findIndex(
                      (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                    ),
                )
            : []
        }
        onOptionSelect={(val: string) => {
          const targetObj = requisiteOptions.find(
            (item: { name: string; inn: string }) => item.name === val,
          );
          setFormState({
            ...formState,
            inn: targetObj?.inn ? targetObj.inn : '',
            ogrn: targetObj?.ogrn ? targetObj.ogrn : '',
            address: targetObj?.address
              ? `г ${targetObj.address.city},${targetObj.address.street}, д ${targetObj.address.house}`
              : '',
            companyName: val,
          });
          clearRequisiteOptions();
        }}
      />
      <Row gutter={16}>
        <Col span={12}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.country}
            postfix=""
            label="страна*"
            placeholder=""
            onChange={(e) => handleChange('country', e.target.value)}
            autoComplete="off"
          />
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.phoneNumber}
            postfix=""
            label="телефон*"
            placeholder=""
            autoComplete="off"
            onChange={(e) =>
              handleChange('phoneNumber', e.target.value.replace(/[^\d+]/g, ''))
            }
            mask={[
              '+',
              '7',
              ' ',
              '(',
              /[1-9]/,
              /\d/,
              /\d/,
              ')',
              ' ',
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
            ]}
            blocker={false}
          />
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.inn}
            postfix=""
            label="ИНН"
            placeholder=""
            onChange={(e) => handleChange('inn', e.target.value, 'number')}
            autoComplete="off"
          />
        </Col>
        <Col span={12}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.address}
            postfix=""
            label="адрес*"
            placeholder=""
            onChange={(e) => {
              handleChange('address', e.target.value);
              searchBuyersAddressFx(`${formState.address}`);
            }}
            options={
              Array.isArray(addressOptions)
                ? addressOptions
                    ?.map((item: any) => ({ label: item.value }))
                    .filter((item: { label: string }) => item.label)
                    .filter(
                      (value: { label: string }, index: number, self: any) =>
                        index ===
                        self.findIndex(
                          (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                        ),
                    )
                : []
            }
            onOptionSelect={(val: string) => {
              setSelectedAddressOption(
                addressOptions.find((item: any) => item.value === val),
              );
              handleChange('address', val);
              clearAddressOptions();
            }}
            autoComplete="off"
          />
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.email}
            postfix=""
            label="e-mail*"
            placeholder=""
            onChange={(e) => handleChange('email', e.target.value)}
            autoComplete="off"
          />
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.ogrn}
            postfix=""
            label="ОГРН"
            placeholder=""
            onChange={(e) => handleChange('ogrn', e.target.value, 'number')}
            autoComplete="off"
          />
        </Col>
      </Row>
      {/* <h3>адрес пункта приема зерна*</h3>
      <Row gutter={16}>
        <Col span={12}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.region}
            postfix=""
            label="область*"
            placeholder=""
            onChange={(e) => {
              handleChange('region', e.target.value);
              searchBuyersAddressFx(formState.region);
            }}
            options={Array.isArray(addressOptions) ? addressOptions
              ?.map((item: any) => ({ label: item.region }))
              .filter(
                (value: { label: string}, index: number, self: any) =>
                  index ===
                  self.findIndex(
                    (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                  ),
              ) : []}
            onOptionSelect={(val: string) => {
              handleChange('region', val);
            }}
          />
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.street}
            postfix=""
            label="улица*"
            placeholder=""
            onChange={(e) => {
              handleChange('street', e.target.value);
              searchBuyersAddressFx(
                `${formState.region}, ${formState.city}, ${formState.street}`,
              );
            }}
            options={Array.isArray(addressOptions) ? addressOptions
              ?.map((item: any) => ({ label: item.street }))
              ?.filter((item: { label: string}) => item.label)
              .filter(
                (value: { label: string}, index: number, self: any) =>
                  index ===
                  self.findIndex(
                    (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                  ),
              ) : []}
            onOptionSelect={(val: string) => {
              handleChange('street', val);
            }}
          />
        </Col>
        <Col span={12}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.city}
            postfix=""
            label="город/населенный пункт*"
            placeholder=""
            onChange={(e) => {
              handleChange('city', e.target.value);
              searchBuyersAddressFx(`${formState.region}, ${formState.city}`);
            }}
            options={Array.isArray(addressOptions) ? addressOptions
              ?.map((item: any) => ({ label: item.city }))
              .filter((item: { label: string}) => item.label)
              .filter(
                (value: { label: string}, index: number, self: any) =>
                  index ===
                  self.findIndex(
                    (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                  ),
              ): []}
            onOptionSelect={(val: string) => {
              handleChange('city', val);
            }}
          />
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.house}
            postfix=""
            label="дом/павильон*"
            placeholder=""
            onChange={(e) => {
              handleChange('house', e.target.value);
              searchBuyersAddressFx(
                `${formState.region}, ${formState.city}, ${formState.street}, ${formState.house}`,
              );
            }}
            options={Array.isArray(addressOptions) ? addressOptions
              ?.map((item: any) => ({ label: item.house }))
              .filter((item: { label: string}) => item.label)
              .filter(
                (value: { label: string}, index: number, self: any) =>
                  index ===
                  self.findIndex(
                    (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                  ),
              ) : []}
            onOptionSelect={(val: string) => {
              handleChange('house', val);
            }}
          />
        </Col>
        <Col span={24}>
          <InputWithSign
            className={classNames(styles.input)}
            value={`${formState.region && formState.region + ', ' } ${formState.city && formState.city + ', '} ${formState.street && formState.street + ', '} ${formState.house}`}
            postfix=""
            placeholder=""
            onChange={() => {}}
          />
        </Col>
      </Row> */}
      <div className={styles.actions}>
        <ButtonPrimary
          className={styles.actionButton}
          label={'добавить покупателя'}
          onClick={() =>
            handleSubmit({
              company_name: formState.companyName,
              country: formState.country,
              address: formState.address,
              tel: formState.phoneNumber,
              email: formState.email,
              inn: formState.inn,
              ogrn: formState.ogrn,
              region: selectedAddressOption.region || '',
              city: selectedAddressOption.city || '',
              street: selectedAddressOption.street || '',
              house: selectedAddressOption.house || '',
            })
          }
        />
      </div>
    </Modal>
  );
};

interface IAddBuyerModal {
  visible: boolean;
  closeFn: () => void;
  handleSubmit: (dto: BuyerInstance) => void;
}
